import React from 'react';
import { Box } from '@mui/material';
import ServiceModeHubsStep from './ServiceModeHubsStep';
import ServiceAreaStep from './ServiceAreaStep';
import type { ServiceMode } from './types';

interface ConfigurationStepProps {
  serviceMode: ServiceMode | null;
  requiresHubs: boolean;
  hubCount: number;
  onSelectMode: (mode: ServiceMode) => void;
  polygonCount: number;
  serviceAreaPolygonLabel: string | null;
  onDrawPolygon: () => void;
}

export default function ConfigurationStep({
  serviceMode,
  requiresHubs,
  hubCount,
  onSelectMode,
  polygonCount,
  serviceAreaPolygonLabel,
  onDrawPolygon,
}: ConfigurationStepProps) {
  const hasServiceAreaPolygon = polygonCount > 0;

  return (
    <Box sx={{ maxWidth: 980, mx: 'auto', display: 'grid', gap: 3 }}>
      <ServiceModeHubsStep
        serviceMode={serviceMode}
        onSelectMode={onSelectMode}
      />

      <ServiceAreaStep
        polygonCount={polygonCount}
        hubCount={hubCount}
        requiresHubs={requiresHubs}
        onDrawPolygon={onDrawPolygon}
      />
    </Box>
  );
}
